// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AI4wi","form":"styles_form__pcGtg","submit":"styles_submit__gbFvl","title":"styles_title__e2+rc"};